import Div from "@jumbo/shared/Div";
import PermMediaIcon from "@mui/icons-material/PermMedia";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField
} from "@mui/material";
import Typography from "@mui/material/Typography";
import AllApis from "app/Apis/apis";
import { percentageValue } from "app/pages/Component/Function/Percentage";
import { Form, Formik } from "formik";
import { Axios } from "index";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as yup from "yup";

const disabledStyling = {
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#475259",
  },
  "& .MuiInputLabel-root": {
    color: "#475259", // Change label color to blue
  },
};


function AddStockForm({ POdata }) {
  const navigate = useNavigate();
  const [totalData, setTotalData] = useState({
    total_weight: POdata?.current_data?.total_weight || 0,
    total_quantity: POdata?.current_data?.total_quantity || 0,
    total_pending_quantity: POdata?.current_data?.total_pending_quantity || 0,
    total_receivedQuantity: POdata?.current_data?.total_receivedQuantity || 0,
    total_item_amount: POdata?.current_data?.total_item_amount || 0,
    total_cgst: POdata?.current_data?.total_cgst || 0,
    total_sgst: POdata?.current_data?.total_sgst || 0,
    total_igst: POdata?.current_data?.total_igst || 0,
    total_amount: POdata?.current_data?.total_amount || 0,
  })

  const handleImagesTab = async (value) => {
    if (value && typeof value === "string") {
      const imageURL = new URL(`${process.env.REACT_APP_IMAGE_URL}/${value}`);
      window.open(imageURL.href, "_blank");
    } else {
      const images = URL.createObjectURL(value);
      window.open(images, "__blank");
    }
  };
  const InitialValues = {
    purchaseOrderNo: POdata?.current_data?.purchase_order_no
      ? POdata?.current_data?.purchase_order_no
      : "",
    supplierDetails: {
      SupplierCompanyName: POdata?.current_data?.supplier_details?.company_name
        ? POdata?.current_data?.supplier_details?.company_name
        : "",
      supplierId: POdata?.current_data?.supplier_details?.supplier_id
        ? POdata?.current_data?.supplier_details?.supplier_id
        : "",
      branchId: POdata?.current_data?.supplier_details?.branch_id
        ? POdata?.current_data?.supplier_details?.branch_id
        : "",
      gstNo: POdata?.current_data?.supplier_details?.gst_no
        ? POdata?.current_data?.supplier_details?.gst_no
        : "",
      firstName: POdata?.current_data?.supplier_details?.first_name
        ? POdata?.current_data?.supplier_details?.first_name
        : "",
      lastName: POdata?.current_data?.supplier_details?.last_name
        ? POdata?.current_data?.supplier_details?.last_name
        : "",
      primaryEmailID: POdata?.current_data?.supplier_details?.primary_email_id
        ? POdata?.current_data?.supplier_details?.primary_email_id
        : "",
      secondaryEmailID: POdata?.current_data?.supplier_details
        ?.secondary_email_id
        ? POdata?.current_data?.supplier_details?.secondary_email_id
        : "",
      primaryMobileNo: POdata?.current_data?.supplier_details?.primary_mobile_no
        ? POdata?.current_data?.supplier_details?.primary_mobile_no
        : "",
      secondaryMobileNo: POdata?.current_data?.supplier_details
        ?.secondary_mobile_no
        ? POdata?.current_data?.supplier_details?.secondary_mobile_no
        : "",
      address: {
        address: POdata?.current_data?.supplier_details?.address?.address
          ? POdata?.current_data?.supplier_details?.address?.address
          : "",
        location: POdata?.current_data?.supplier_details?.address?.location
          ? POdata?.current_data?.supplier_details?.address?.location
          : "",
        area: POdata?.current_data?.supplier_details?.address?.area
          ? POdata?.current_data?.supplier_details?.address?.area
          : "",
        district: POdata?.current_data?.supplier_details?.address?.district
          ? POdata?.current_data?.supplier_details?.address?.district
          : "",
        taluka: POdata?.current_data?.supplier_details?.address?.taluka
          ? POdata?.current_data?.supplier_details?.address?.taluka
          : "",
        state: POdata?.current_data?.supplier_details?.address?.state
          ? POdata?.current_data?.supplier_details?.address?.state
          : "",
        city: POdata?.current_data?.supplier_details?.address?.city
          ? POdata?.current_data?.supplier_details?.address?.city
          : "",
        country: POdata?.current_data?.supplier_details?.address?.country
          ? POdata?.current_data?.supplier_details?.address?.country
          : "",
        pincode: POdata?.current_data?.supplier_details?.address?.pincode
          ? POdata?.current_data?.supplier_details?.address?.pincode
          : "",
      },
    },
    itemsDetails: POdata?.current_data?.Items
      ? POdata?.current_data?.Items.map((item) => ({
        ...item,
        receivedQuantity: 1,
        checked: false
      }))
      : [],
    transportDetails: {
      transport: "",
      deliveryChallanNo: "",
      transportType: {
        handDelivery: {
          personName: "",
          personNumber: "",
        },
        courier: {
          companyName: "",
          docketNumber: "",
        },
        road: {
          transporterName: "",
          vehicleNumber: "",
          driverName: "",
          driverNumber: "",
        },
        airRail: {
          transporterName: "",
          airRail: "",
          awbNumber: "",
        },

        deliveryChallanNo_image: "",
      },
    },
    invoiceDetails: {
      invoiceNo: "",
      invoiceDate: new Date(Date.now()).toISOString().split('T')[0],
      itemsAmount: 0,
      discountPercentage: 0,
      discountAmount: 0,
      gstPercentage: 0,
      gstAmount: 0,
      totalAmount: 0,
      uploadInviocePDF: "",
    },
    receivedDate: new Date(Date.now()).toISOString().split('T')[0],
  };
  const handleSubmit = async (values) => {
    try {
      const itemsDetails = values.itemsDetails.filter((e) => e.checked);
      if (itemsDetails?.length <= 0) {
        Swal.fire({
          title: "Failed",
          text: "Please Select the product",
          icon: "warning",
          timer: 1500,
          showConfirmButton: false,
        });
        return;
      }
      let formdata = new FormData();
      formdata.append("purchaseOrderNo", JSON.stringify(values.purchaseOrderNo));
      formdata.append("supplierDetails", JSON.stringify(values.supplierDetails));
      formdata.append("itemsDetails", JSON.stringify(itemsDetails));
      formdata.append("transportDetails", JSON.stringify(values.transportDetails));
      formdata.append("invoiceDetails", JSON.stringify(values.invoiceDetails));
      formdata.append("deliveryChallanNo_image", values.transportDetails.transportType.deliveryChallanNo_image);
      formdata.append("uploadInviocePDF", values.invoiceDetails.uploadInviocePDF);
      formdata.append("receivedDate", values.receivedDate);
      let response = await Axios.post(AllApis.inventory.add, formdata);
      if (response?.data?.statusCode) {
        Swal.fire({
          title: "Inventory Updated successfully",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
        navigate("/dashboards/inventory");
      }
    } catch (error) {
      Swal.fire({
        title: error?.response?.data.message,
        icon: "error",
        timer: 1000,
        showConfirmButton: false,
      });
    }

  };
  const validationSchema = yup.object().shape({
    transportDetails: yup.object().shape({
      transport: yup.string().required('Transport type is required'),
      deliveryChallanNo: yup.string().required('Challan Number is required'),
      transportType: yup.object().shape({
        handDelivery: yup.object().when('transport', (val, schema, contextDetails) => {
          const { context: { transportDetails: { transport } } } = contextDetails
          return transport === 'handDelivery' ? schema.shape({
            personName: yup.string().required('Person Name is required'),
            personNumber: yup.string()
              .required('Person Phone Number is required')
              .matches(/^[0-9]{10}$/, 'Person Phone Number must be exactly 10 digits'),
          }) : schema.nullable();
        }),
        courier: yup.object().when('transport', (val, schema, contextDetails) => {
          const { context: { transportDetails: { transport } } } = contextDetails
          return transport === 'courier' ? schema.shape({
            companyName: yup.string().required('Company Name is required'),
            docketNumber: yup.string().required('Docket Number is required'),
          }) : schema.nullable();
        }),
        road: yup.object().when('transport', (val, schema, contextDetails) => {
          const { context: { transportDetails: { transport } } } = contextDetails
          return transport === 'road' ? schema.shape({
            transporterName: yup.string().required('Transporter Name is required'),
            vehicleNumber: yup.string().required('Vehicle Number is required'),
            driverName: yup.string().required('Driver Name is required'),
            driverNumber: yup.string()
              .required('Driver Phone Number is required')
              .matches(/^[0-9]{10}$/, 'Driver Phone Number must be exactly 10 digits'),
          }) : schema.nullable();
        }),
        airRail: yup.object().when('transport', (val, schema, contextDetails) => {
          const { context: { transportDetails: { transport } } } = contextDetails
          return transport === 'airRail' ? schema.shape({
            transporterName: yup.string().required('Transporter Name is required'),
            airRail: yup.string().required('Transport Type (Air/Rail) is required'),
            awbNumber: yup.string().required('AWB Number is required'),
          }) : schema.nullable();
        }),
      }),
      deliveryChallanNo_image: yup.string(),
    }),
    invoiceDetails: yup.object().shape({
      invoiceNo: yup.string().required('Invoice number is required.'),
      invoiceDate: yup.date().required('Invoice date is required.'),
      itemsAmount: yup.number().required('Items amount is required.').min(0, 'Items amount cannot be negative.'),
      discountPercentage: yup.number().required('Discount percentage is required.').min(0, 'Discount percentage cannot be negative.'),
      discountAmount: yup.number().required('Discount amount is required.').min(0, 'Discount amount cannot be negative.'),
      gstPercentage: yup.number().required('GST percentage is required.').min(0, 'GST percentage cannot be negative.'),
      gstAmount: yup.number().required('GST amount is required.').min(0, 'GST amount cannot be negative.'),
      totalAmount: yup.number().required('Total amount is required.').min(0, 'Total amount cannot be negative.'),
      uploadInviocePDF: yup.string().url('Must be a valid URL.'),
    })
  });


  const handleCheck = function (e, i, setFieldValue, values) {
    const { name, checked } = e.target;
    setFieldValue(name, checked)
    if (checked) {
      const initailTotals = {
        total_weight: 0,
        total_quantity: 0,
        total_pending_quantity: 0,
        total_receivedQuantity: 0,
        total_item_amount: 0,
        total_cgst: 0,
        total_sgst: 0,
        total_igst: 0,
        total_amount: 0
      }
      const valueItemDetail = JSON.parse(JSON.stringify(values?.itemsDetails[i]));
      valueItemDetail.item_amount = valueItemDetail.rate_per_unit * valueItemDetail.receivedQuantity;
      const gstValue = percentageValue(valueItemDetail.item_amount, valueItemDetail?.gst?.cgst + valueItemDetail?.gst?.sgst + valueItemDetail?.gst?.igst)

      valueItemDetail.total_amount = valueItemDetail.item_amount + gstValue;
      valueItemDetail.checked = checked;

      const initailItemDetails = JSON.parse(JSON.stringify(values?.itemsDetails));
      initailItemDetails[i] = valueItemDetail;

      const totals = initailItemDetails?.filter((e) => e.checked)?.reduce((acc, item, index) => {
        const item_amount = item.receivedQuantity * item.rate_per_unit
        const total_cgst = percentageValue(item_amount, item.gst.cgst)
        const total_sgst = percentageValue(item_amount, item.gst.sgst)
        const total_igst = percentageValue(item_amount, item.gst.igst)
        acc.total_weight += item.weight * item.receivedQuantity;
        acc.total_quantity += item.quantity;
        acc.total_pending_quantity += item.pending_quantity;
        acc.total_receivedQuantity += item.receivedQuantity;
        acc.total_item_amount += item_amount;
        acc.total_cgst += total_cgst;
        acc.total_sgst += total_sgst;
        acc.total_igst += total_igst;
        acc.total_amount += item.total_amount;
        return acc;
      }, initailTotals);
      setTotalData(totals)
      setFieldValue(`itemsDetails.${i}`, valueItemDetail)
      const itemsAmount = totals.total_item_amount;
      const discountAmount = percentageValue(itemsAmount, values.invoiceDetails.discountPercentage);
      const discountedAmount = itemsAmount - discountAmount;
      const gstAmount = percentageValue(discountedAmount, values.invoiceDetails.gstPercentage);
      const totalAmount = discountedAmount + gstAmount;

      setFieldValue("invoiceDetails", {
        ...values.invoiceDetails,
        itemsAmount: itemsAmount,
        discountAmount: discountAmount,
        gstAmount: gstAmount,
        totalAmount: totalAmount,
      });

    } else {
      const initailTotals = {
        total_weight: 0,
        total_quantity: 0,
        total_pending_quantity: 0,
        total_receivedQuantity: 0,
        total_item_amount: 0,
        total_cgst: 0,
        total_sgst: 0,
        total_igst: 0,
        total_amount: 0
      }
      const initailItemDetails = JSON.parse(JSON.stringify(values?.itemsDetails));
      initailItemDetails[i] = InitialValues?.itemsDetails?.[i];
      const all = initailItemDetails?.every((e) => !e.checked)
      
      const totals = initailItemDetails?.filter((e) => all ? !e.checked : e.checked)?.reduce((acc, item, index) => {
        acc.total_weight += item.weight * item.quantity;
        acc.total_quantity += item.quantity;
        acc.total_pending_quantity += item.pending_quantity;
        acc.total_receivedQuantity += item.receivedQuantity;
        acc.total_item_amount += item.item_amount;
        acc.total_cgst += percentageValue(item.item_amount, item.gst.cgst);
        acc.total_sgst += percentageValue(item.item_amount, item.gst.sgst);
        acc.total_igst += percentageValue(item.item_amount, item.gst.igst);
        acc.total_gst += percentageValue(item.item_amount, item.gst.igst);
        acc.total_amount += item.total_amount;
        if (all) {
          acc.total_receivedQuantity = 0
        }
        return acc;
      }, initailTotals);
      setTotalData(totals)
      setFieldValue(`itemsDetails.${i}`, InitialValues?.itemsDetails?.[i])
      if (all) {
        setFieldValue("invoiceDetails", InitialValues.invoiceDetails)
      } else {
        const itemsAmount = totals.total_item_amount;
        const discountAmount = percentageValue(itemsAmount, values.invoiceDetails.discountPercentage);
        const discountedAmount = itemsAmount - discountAmount;
        const gstAmount = percentageValue(discountedAmount, values.invoiceDetails.gstPercentage);
        const totalAmount = discountedAmount + gstAmount;

        setFieldValue("invoiceDetails", {
          ...values.invoiceDetails,
          itemsAmount: itemsAmount,
          discountAmount: discountAmount,
          gstAmount: gstAmount,
          totalAmount: totalAmount,
        });
      }
    }
  }

  const handleReceviedQuantityChange = function (e, i, setFieldValue, values) {
    const { value, name } = e.target;
    let receivedQuantityValue = parseInt(value)

    if(receivedQuantityValue > values?.itemsDetails[i]?.pending_quantity){
      receivedQuantityValue = values?.itemsDetails[i]?.pending_quantity
    }
    setFieldValue(name, receivedQuantityValue)
    const initailTotals = {
      total_weight: 0,
      total_quantity: 0,
      total_pending_quantity: 0,
      total_receivedQuantity: 0,
      total_item_amount: 0,
      total_cgst: 0,
      total_sgst: 0,
      total_igst: 0,
      total_amount: 0
    }
    const valueItemDetail = JSON.parse(JSON.stringify(values?.itemsDetails[i]));
    valueItemDetail.item_amount = valueItemDetail.rate_per_unit * receivedQuantityValue;
    const gstValue = percentageValue(valueItemDetail.item_amount, valueItemDetail?.gst?.cgst + valueItemDetail?.gst?.sgst + valueItemDetail?.gst?.igst)

    valueItemDetail.total_amount = valueItemDetail.item_amount + gstValue;
    valueItemDetail.receivedQuantity = receivedQuantityValue;

    const initailItemDetails = JSON.parse(JSON.stringify(values?.itemsDetails));
    initailItemDetails[i] = valueItemDetail;

    const totals = initailItemDetails?.filter((e) => e.checked)?.reduce((acc, item, index) => {
      acc.total_weight += item.weight * item.quantity;
      acc.total_quantity += item.quantity;
      acc.total_pending_quantity += item.pending_quantity;
      acc.total_receivedQuantity += item.receivedQuantity;
      acc.total_item_amount += item.rate_per_unit * item.receivedQuantity;
      acc.total_cgst += percentageValue(item.rate_per_unit * item.receivedQuantity, item.gst.cgst);
      acc.total_sgst += percentageValue(item.rate_per_unit * item.receivedQuantity, item.gst.sgst);
      acc.total_igst += percentageValue(item.rate_per_unit * item.receivedQuantity, item.gst.igst);
      acc.total_amount += item.total_amount;
      return acc;
    }, initailTotals);
    setTotalData(totals)
    setFieldValue(`itemsDetails.${i}`, valueItemDetail)
    const itemsAmount = totals.total_item_amount;
    const discountAmount = percentageValue(itemsAmount, values.invoiceDetails.discountPercentage);
    const discountedAmount = itemsAmount - discountAmount;
    const gstAmount = percentageValue(discountedAmount, values.invoiceDetails.gstPercentage);
    const totalAmount = discountedAmount + gstAmount;

    setFieldValue("invoiceDetails", {
      ...values.invoiceDetails,
      itemsAmount: itemsAmount,
      discountAmount: discountAmount,
      gstAmount: gstAmount,
      totalAmount: totalAmount,
    });
  }

  useEffect(() => {
    setTotalData({
      total_weight: POdata?.current_data?.total_weight || 0,
      total_quantity: POdata?.current_data?.total_quantity || 0,
      total_pending_quantity: POdata?.current_data?.total_pending_quantity || 0,
      total_receivedQuantity: POdata?.current_data?.total_receivedQuantity || 0,
      total_item_amount: POdata?.current_data?.total_item_amount || 0,
      total_cgst: POdata?.current_data?.total_cgst || 0,
      total_sgst: POdata?.current_data?.total_sgst || 0,
      total_igst: POdata?.current_data?.total_igst || 0,
      total_amount: POdata?.current_data?.total_amount || 0,
    })
  }, [POdata])

  return (
    <>
      <Div sx={{ mt: "-4px" }}>
        <Box sx={{ marginTop: "2%" }}>
          <Formik
            key={POdata}
            enableReinitialize={true}
            initialValues={InitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              setFieldValue,
              handleChange,
              isSubmitting,
              handleSubmit,
              touched,
              errors,
            }) => {
              return (
                <>
                  <Form>
                    <Typography variant="h3">Supplier Details</Typography>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 4,
                        gap: 3,
                        margin: "2% 0",
                      }}
                    >
                      <TextField
                        name="purchaseOrderNo"
                        type="text"
                        value={values.purchaseOrderNo}
                        label="Purchase Order No"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />

                      <TextField
                        name="receivedDate"
                        type="date"
                        value={values.receivedDate}
                        label="Received Date"
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={handleChange}
                      />
                    </Div>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 2,
                        gap: 3,
                        margin: "2% 0",
                      }}
                    >
                      <TextField
                        name="SupplierCompanyName"
                        type="text"
                        value={values.supplierDetails.SupplierCompanyName}
                        label="Supplier Name"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.gstNo"
                        type="text"
                        value={values?.supplierDetails?.gstNo}
                        label="GST No"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.firstName"
                        type="text"
                        value={values?.supplierDetails?.firstName}
                        label="First Name"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.lastName"
                        type="text"
                        value={values?.supplierDetails?.lastName}
                        label="Last Name"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.primaryEmailID"
                        type="text"
                        value={values?.supplierDetails?.primaryEmailID}
                        label="Primary Email ID"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.secondaryEmailID"
                        type="text"
                        value={values?.supplierDetails?.secondaryEmailID}
                        label="Secondary Email ID"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.primaryMobileNo"
                        type="text"
                        value={values?.supplierDetails?.primaryMobileNo}
                        label="Primary MobileNo"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.secondaryMobileNo"
                        type="text"
                        value={values?.supplierDetails?.secondaryMobileNo}
                        label="Secondary Mobile No."
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                    </Div>
                    <Typography variant="h3">Supplier Address</Typography>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 4,
                        gap: 3,
                        margin: "2% 0",
                      }}
                    >
                      <TextField
                        name="supplierDetails.address.address"
                        type="text"
                        value={values?.supplierDetails?.address?.address}
                        label="Address"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.location"
                        type="text"
                        value={values?.supplierDetails?.address?.location}
                        label="Address"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.area"
                        type="text"
                        value={values?.supplierDetails?.address?.area}
                        label="Area"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.district"
                        type="text"
                        value={values?.supplierDetails?.address?.district}
                        label="District"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.taluka"
                        type="text"
                        value={values?.supplierDetails?.address?.taluka}
                        label="Taluka"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.state"
                        type="text"
                        value={values?.supplierDetails?.address?.state}
                        label="State"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.city"
                        type="text"
                        value={values?.supplierDetails?.address?.city}
                        label="City"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.country"
                        type="text"
                        value={values?.supplierDetails?.address?.country}
                        label="Country"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="supplierDetails.address.pincode"
                        type="text"
                        value={values?.supplierDetails?.address?.pincode}
                        label="Pincode"
                        disabled={true}
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                    </Div>
                    <Typography variant="h3">Item Details</Typography>

                    <TableContainer component={Paper} sx={{ mt: 3 }}>
                      <Table>
                        <TableHead>
                          <TableRow sx={{ bgcolor: "#7352C7", color: "white" }}>
                            {[
                              "Select",
                              "Items Name",
                              "Category",
                              "SKU",
                              "HSN Code",
                              "Unit",
                              "Rate per unit",
                              "CGST %",
                              "SGST %",
                              "IGST %",
                              "Items Weight",
                              "Quantity",
                              "Pending Quantity",
                              "Received Quantity",
                              "Item Amount",
                              "CGST Amt",
                              "SGST Amt",
                              "IGST Amt",
                              "Total Amount",
                            ].map((ele, i) => {
                              return (
                                <TableCell
                                  align="left"
                                  key={i}
                                  sx={{
                                    textTransform: "capitalize",
                                    color: "white",
                                    textAlign: "left",
                                    minWidth: ele !== "Select" ? "180px" : "80px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  {ele}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {values?.itemsDetails &&
                            values?.itemsDetails.map((row, i) => {
                              return (
                                <TableRow key={i} sx={{ background: row["checked"] ? "#7352c71a" : "transparent", width: "100%" }}>
                                  <TableCell
                                    sx={{
                                      textAlign: "left",
                                      width: "100%",
                                    }}
                                  >
                                    <Checkbox
                                      checked={row["checked"]}
                                      // disabled={row.receivedQuantity == 0}
                                      onChange={(e) => handleCheck(e, i, setFieldValue, values)}
                                      name={`itemsDetails.${i}.checked`}
                                      inputProps={{ "aria-label": "controlled" }}
                                    />
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.item_name}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.category}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.sku}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.hsn_code}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.unit}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.rate_per_unit}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.gst?.cgst}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.gst?.sgst}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.gst?.igst}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.weight}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.quantity}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.pending_quantity}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    <TextField
                                      name={`itemsDetails.${i}.receivedQuantity`}
                                      type="number"
                                      value={
                                        row.receivedQuantity
                                      }
                                      inputProps={{
                                        min: 1,
                                        max: row?.pending_quantity,
                                      }}
                                      disabled={!row?.checked}
                                      // label="Received Quantity"
                                      size="small"
                                      sx={{
                                        width: "100%",
                                      }}
                                      onChange={(e) => handleReceviedQuantityChange(e, i, setFieldValue, values)}
                                    />
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.item_amount}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {percentageValue(row?.item_amount, row?.gst?.cgst)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {percentageValue(row?.item_amount, row?.gst?.sgst)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {percentageValue(row?.item_amount, row?.gst?.igst)}
                                  </TableCell>
                                  <TableCell sx={{ textAlign: "left" }}>
                                    {row?.total_amount}
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                          <TableRow sx={{ borderTop: "2px solid #7352C7" }}>
                            <TableCell
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                              colSpan={10}
                            >
                              Total
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_weight?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_quantity?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_pending_quantity?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_receivedQuantity?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_item_amount?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_cgst?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_sgst?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_igst?.toFixed(2) || 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              sx={{ textAlign: "left", fontSize: "15px", fontWeight: 600 }}
                            >
                              {totalData?.total_amount?.toFixed(2) || 0}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <Typography variant="h3" sx={{ margin: "1.5% 0" }}>
                      Invoice Details
                    </Typography>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 4,
                        gap: 3,
                        margin: "1% 0",
                      }}
                    >
                      <TextField
                        name="invoiceDetails.invoiceNo"
                        type="text"
                        value={values?.invoiceDetails?.invoiceNo}
                        label="Invoice Number"
                        error={errors?.invoiceDetails?.invoiceNo && touched?.invoiceDetails?.invoiceNo}
                        helperText={
                          errors?.invoiceDetails?.invoiceNo && touched?.invoiceDetails?.invoiceNo
                            ? errors?.invoiceDetails?.invoiceNo
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%" }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="invoiceDetails.invoiceDate"
                        type="date"
                        value={values?.invoiceDetails?.invoiceDate}
                        label="Invoice Date"
                        error={errors?.invoiceDetails?.invoiceDate && touched?.invoiceDetails?.invoiceDate}
                        helperText={
                          errors?.invoiceDetails?.invoiceDate && touched?.invoiceDetails?.invoiceDate
                            ? errors?.invoiceDetails?.invoiceDate
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%" }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="invoiceDetails.itemsAmount"
                        type="number"
                        value={values?.invoiceDetails?.itemsAmount}
                        label="Items Amount"
                        error={errors?.invoiceDetails?.itemsAmount && touched?.invoiceDetails?.itemsAmount}
                        helperText={
                          errors?.invoiceDetails?.itemsAmount && touched?.invoiceDetails?.itemsAmount
                            ? errors?.invoiceDetails?.itemsAmount
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%" }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="invoiceDetails.discountPercentage"
                        type="number"
                        value={values?.invoiceDetails?.discountPercentage}
                        label="Discount Percentage"
                        error={errors?.invoiceDetails?.discountPercentage && touched?.invoiceDetails?.discountPercentage}
                        helperText={
                          errors?.invoiceDetails?.discountPercentage && touched?.invoiceDetails?.discountPercentage
                            ? errors?.invoiceDetails?.discountPercentage
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%" }}
                        onChange={(e) => {
                          const { value, name } = e.target;
                          const discountValue = parseFloat(value);
                          const discountAmount = percentageValue(values.invoiceDetails.itemsAmount, discountValue);
                          const discountedAmount = values.invoiceDetails.itemsAmount - discountAmount;
                          const gstAmount = percentageValue(discountedAmount, values.invoiceDetails.gstPercentage);
                          const totalAmount = discountedAmount + gstAmount;

                          setFieldValue("invoiceDetails", {
                            ...values.invoiceDetails,
                            discountPercentage: discountValue,
                            discountAmount: discountAmount,
                            gstAmount: gstAmount,
                            totalAmount: totalAmount,
                          });
                        }}
                      />
                      <TextField
                        name="invoiceDetails.discountAmount"
                        type="number"
                        value={values?.invoiceDetails?.discountAmount}
                        label="Discount Amount"
                        disabled
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        onChange={handleChange}
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}

                      />
                      <TextField
                        name="invoiceDetails.discountItemAmount"
                        type="number"
                        value={values.invoiceDetails.itemsAmount - values.invoiceDetails.discountAmount}
                        label="Discount Item Amount"
                        disabled
                        // error={errors?.employee_id && touched?.employee_id}
                        // helperText={
                        //   errors?.employee_id && touched?.employee_id
                        //     ? errors?.employee_id
                        //     : ""
                        // }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}

                      />
                      <TextField
                        name="invoiceDetails.gstPercentage"
                        type="number"
                        value={values?.invoiceDetails?.gstPercentage}
                        label="GST Percentage"
                        error={errors?.invoiceDetails?.gstPercentage && touched?.invoiceDetails?.gstPercentage}
                        helperText={
                          errors?.invoiceDetails?.gstPercentage && touched?.invoiceDetails?.gstPercentage
                            ? errors?.invoiceDetails?.gstPercentage
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%" }}
                        onChange={(e) => {
                          const { value, name } = e.target;
                          const gstValue = parseFloat(value);
                          const discountValueAmt = values.invoiceDetails.itemsAmount - values.invoiceDetails.discountAmount
                          const gstAmt = percentageValue(discountValueAmt, gstValue)
                          setFieldValue(name, gstValue);
                          setFieldValue("invoiceDetails.gstAmount", gstAmt)
                          setFieldValue("invoiceDetails.totalAmount", discountValueAmt + gstAmt)
                        }}
                      />
                      <TextField
                        name="invoiceDetails.gstAmount"
                        type="number"
                        value={values?.invoiceDetails?.gstAmount}
                        label="GST Amount"
                        disabled
                        error={errors?.invoiceDetails?.gstAmount && touched?.invoiceDetails?.gstAmount}
                        helperText={
                          errors?.invoiceDetails?.gstAmount && touched?.invoiceDetails?.gstAmount
                            ? errors?.invoiceDetails?.gstAmount
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="invoiceDetails.totalAmount"
                        type="number"
                        value={values?.invoiceDetails?.totalAmount || 0}
                        label="Total Amount"
                        disabled
                        error={errors?.invoiceDetails?.totalAmount && touched?.invoiceDetails?.totalAmount}
                        helperText={
                          errors?.invoiceDetails?.totalAmount && touched?.invoiceDetails?.totalAmount
                            ? errors?.invoiceDetails?.totalAmount
                            : ""
                        }
                        size="small"
                        sx={{ width: "22%", ...disabledStyling }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="invoiceDetails.uploadInviocePDF"
                        type="file"
                        size="small"
                        sx={{ width: "22%" }}
                        // value={values.profile_pic}
                        label="Upload Invoice"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        // onChange={(e) => handleFileChange(e, "profile_pic")}
                        onChange={(e) =>
                          setFieldValue(
                            "invoiceDetails.uploadInviocePDF",
                            e.target.files[0]
                          )
                        }
                        variant="outlined"
                      />
                      {values?.invoiceDetails?.uploadInviocePDF && (
                        <Button
                          sx={{ "&:hover": { bgcolor: "transparent" } }}
                          onClick={() => {
                            handleImagesTab(
                              values?.invoiceDetails?.uploadInviocePDF
                            );
                          }}
                        >
                          <PermMediaIcon sx={{ height: "100%" }} />
                        </Button>
                      )}
                    </Div>
                    <Typography variant="h3" sx={{ margin: "1.5% 0" }}>
                      Transport Details
                    </Typography>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 4,
                        gap: 3,
                        margin: "1.5% 0",
                      }}
                    >
                      <TextField
                        name="transportDetails.deliveryChallanNo"
                        type="text"
                        value={values?.transportDetails?.deliveryChallanNo}
                        label="Delivery Challan Number"
                        error={errors?.transportDetails?.deliveryChallanNo && touched?.transportDetails?.deliveryChallanNo}
                        helperText={
                          errors?.transportDetails?.deliveryChallanNo && touched?.transportDetails?.deliveryChallanNo
                            ? errors?.transportDetails?.deliveryChallanNo
                            : ""
                        }
                        size="small"
                        sx={{ width: "30%" }}
                        onChange={handleChange}
                      />
                      <TextField
                        name="transportDetails.transportType.deliveryChallanNo_image"
                        type="file"
                        size="small"
                        sx={{ width: "30%" }}
                        // value={values.profile_pic}
                        label="Upload Delivery Challan"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        // onChange={(e) => handleFileChange(e, "profile_pic")}
                        onChange={(e) =>
                          setFieldValue(
                            "transportDetails.transportType.deliveryChallanNo_image",
                            e.target.files[0]
                          )
                        }
                        variant="outlined"
                      />
                      {values?.transportDetails?.transportType
                        ?.deliveryChallanNo_image && (
                          <Button
                            sx={{ "&:hover": { bgcolor: "transparent" } }}
                            onClick={() => {
                              handleImagesTab(
                                values?.transportDetails?.transportType
                                  ?.deliveryChallanNo_image
                              );
                            }}
                          >
                            <PermMediaIcon sx={{ height: "100%" }} />
                          </Button>
                        )}
                      <FormControl sx={{ width: "30%" }} size="small" error={errors?.transportDetails?.transport && touched?.transportDetails?.transport}>
                        <InputLabel id="demo-simple-select-label">Transport Type</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="transportDetails.transport"
                          value={values?.transportDetails?.transport}
                          size="small"
                          label="Transport Type"
                          onChange={handleChange}
                        >
                          <MenuItem value={"handDelivery"}>Hand Delivery</MenuItem>
                          <MenuItem value={"courier"}>Courier</MenuItem>
                          <MenuItem value={"airRail"}>Air / Rail</MenuItem>
                          <MenuItem value={"road"}>Road</MenuItem>
                        </Select>
                        <FormHelperText>{
                          errors?.transportDetails?.transport && touched?.transportDetails?.transport
                            ? errors?.transportDetails?.transport
                            : ""
                        }</FormHelperText>
                      </FormControl>
                      {values.transportDetails.transport === "handDelivery" && <Div sx={{ color: "white", display: "flex", gap: 3, width: "100%", flexWrap: "wrap" }}>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.handDelivery.personName"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.handDelivery?.personName
                            }
                            error={errors?.transportDetails?.transportType
                              ?.handDelivery?.personName && touched?.transportDetails?.transportType
                                ?.handDelivery?.personName}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.handDelivery?.personName && touched?.transportDetails?.transportType
                                  ?.handDelivery?.personName
                                ? errors?.transportDetails?.transportType
                                  ?.handDelivery?.personName
                                : ""
                            }
                            label="Person Name"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.handDelivery.personNumber"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.handDelivery?.personNumber
                            }
                            error={errors?.transportDetails?.transportType
                              ?.handDelivery?.personNumber && touched?.transportDetails?.transportType
                                ?.handDelivery?.personNumber}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.handDelivery?.personNumber && touched?.transportDetails?.transportType
                                  ?.handDelivery?.personNumber
                                ? errors?.transportDetails?.transportType
                                  ?.handDelivery?.personNumber
                                : ""
                            }
                            label="Person Mobile No."
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                      </Div>}
                      {values.transportDetails.transport === "courier" && <Div sx={{ color: "white", display: "flex", gap: 3, width: "100%", flexWrap: "wrap" }}>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.courier.companyName"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.courier?.companyName
                            }
                            error={errors?.transportDetails?.transportType
                              ?.courier?.companyName && touched?.transportDetails?.transportType
                                ?.courier?.companyName}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.courier?.companyName && touched?.transportDetails?.transportType
                                  ?.courier?.companyName
                                ? errors?.transportDetails?.transportType
                                  ?.courier?.companyName
                                : ""
                            }
                            label="Company Name"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.courier.docketNumber"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.courier?.docketNumber
                            }
                            error={errors?.transportDetails?.transportType
                              ?.courier?.docketNumber && touched?.transportDetails?.transportType
                                ?.courier?.docketNumber}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.courier?.docketNumber && touched?.transportDetails?.transportType
                                  ?.courier?.docketNumber
                                ? errors?.transportDetails?.transportType
                                  ?.courier?.docketNumber
                                : ""
                            }
                            label="Docket Number"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                      </Div>}
                      {values.transportDetails.transport === "airRail" && <Div sx={{ color: "white", display: "flex", gap: 3, width: "100%", flexWrap: "wrap" }}>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.airRail.transporterName"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.airRail?.transporterName
                            }
                            error={errors?.transportDetails?.transportType
                              ?.airRail?.transporterName && touched?.transportDetails?.transportType
                                ?.airRail?.transporterName}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.airRail?.transporterName && touched?.transportDetails?.transportType
                                  ?.airRail?.transporterName
                                ? errors?.transportDetails?.transportType
                                  ?.airRail?.transporterName
                                : ""
                            }
                            label="Transporter Name"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.airRail.airRail"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.airRail?.airRail
                            }
                            error={errors?.transportDetails?.transportType
                              ?.airRail?.airRail && touched?.transportDetails?.transportType
                                ?.airRail?.airRail}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.airRail?.airRail && touched?.transportDetails?.transportType
                                  ?.airRail?.airRail
                                ? errors?.transportDetails?.transportType
                                  ?.airRail?.airRail
                                : ""
                            }
                            label="Air/Rail"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.airRail.awbNumber"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.airRail?.awbNumber
                            }
                            error={errors?.transportDetails?.transportType
                              ?.airRail?.awbNumber && touched?.transportDetails?.transportType
                                ?.airRail?.awbNumber}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.airRail?.awbNumber && touched?.transportDetails?.transportType
                                  ?.airRail?.awbNumber
                                ? errors?.transportDetails?.transportType
                                  ?.airRail?.awbNumber
                                : ""
                            }
                            label="AWB Number"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                      </Div>}
                      {values.transportDetails.transport === "road" && <Div sx={{ color: "white", display: "flex", gap: 3, width: "100%", flexWrap: "wrap" }}>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.road.transporterName"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.road?.transporterName
                            }
                            error={errors?.transportDetails?.transportType
                              ?.road?.transporterName && touched?.transportDetails?.transportType
                                ?.road?.transporterName}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.road?.transporterName && touched?.transportDetails?.transportType
                                  ?.road?.transporterName
                                ? errors?.transportDetails?.transportType
                                  ?.road?.transporterName
                                : ""
                            }
                            label="Transporter Name"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.road.vehicleNumber"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.road?.vehicleNumber
                            }
                            error={errors?.transportDetails?.transportType
                              ?.road?.vehicleNumber && touched?.transportDetails?.transportType
                                ?.road?.vehicleNumber}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.road?.vehicleNumber && touched?.transportDetails?.transportType
                                  ?.road?.vehicleNumber
                                ? errors?.transportDetails?.transportType
                                  ?.road?.vehicleNumber
                                : ""
                            }
                            label="Vehicle Number"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.road.driverName"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.road?.driverName
                            }
                            error={errors?.transportDetails?.transportType
                              ?.road?.driverName && touched?.transportDetails?.transportType
                                ?.road?.driverName}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.road?.driverName && touched?.transportDetails?.transportType
                                  ?.road?.driverName
                                ? errors?.transportDetails?.transportType
                                  ?.road?.driverName
                                : ""
                            }
                            label="Driver Name"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                        <Div sx={{ width: "30%" }}>
                          <TextField
                            name="transportDetails.transportType.road.driverNumber"
                            type="text"
                            value={
                              values?.transportDetails?.transportType
                                ?.road?.driverNumber
                            }
                            error={errors?.transportDetails?.transportType
                              ?.road?.driverNumber && touched?.transportDetails?.transportType
                                ?.road?.driverNumber}
                            helperText={
                              errors?.transportDetails?.transportType
                                ?.road?.driverNumber && touched?.transportDetails?.transportType
                                  ?.road?.driverNumber
                                ? errors?.transportDetails?.transportType
                                  ?.road?.driverNumber
                                : ""
                            }
                            label="Driver Number"
                            size="small"
                            sx={{
                              width: "100%",
                            }}
                            onChange={handleChange}
                          />
                        </Div>
                      </Div>}
                    </Div>
                    <Div
                      sx={{
                        display: "flex",
                        width: "100%",
                        flexWrap: "wrap",
                        columnGap: 4,
                        gap: 2,
                        margin: "1% 0",
                      }}
                    >
                      <Button
                        sx={{ width: "100px" }}
                        variant="contained"
                        onClick={() => navigate("/dashboards/inventory")}
                      >
                        Back
                      </Button>
                      <Button
                        type="submit"
                        onClick={handleSubmit}
                        variant="contained"
                      >
                        Submit
                      </Button>
                    </Div>
                  </Form>
                </>
              );
            }}
          </Formik>
        </Box>
      </Div>
    </>
  );
}

export default AddStockForm;
